<div id="app-div" class="app-div">
  <div id="show-loading">
    <div class="contenedor-loader">
      <div class="rueda"></div>
    </div>
    <div class="cargando">Cargando...</div>

  </div>

  <app-navbar style="overflow:hidden;"></app-navbar>
</div>
